<template>
    <dx-check-box :value="checkbox" text="Текущие записи" @value-changed="onValueChange" />
    <ai-tree-list-edit-wrapper
        ref="treeListRef"
        :meta="meta"
        :args="args"
        :hasntRoute="true"
        :toRemoveToolbarItemsNames="[
            'choice',
            'copy',
            'edit',
            'addSibling',
            'addChild',
            'delete',
            'save',
            'moveSave',
            'moveTo',
        ]"
        :show-footer="false"
        @treeListEditWrapperMounted="treeListEditWrapperMountedHandler"
    />
</template>
<script setup>
import { DxCheckBox } from 'devextreme-vue/check-box';
import { onMounted, ref } from 'vue';

const focusedRow = ref();
const checkbox = ref(true);
const treeListRef = ref();
const meta = {
    keyExpr: 'kodb',
    parentIdExpr: 'kod_parent',
    selectionMode: 'none',
    title: 'Банки',
    columns: [
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 350,
            index: 1,
            visible: true,
            fixed: true,
        },
        {
            name: 'shortlist',
            caption: 'SHORTLIST',
            dataField: 'shortlist',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            dataType: 'boolean',
            width: 40,
            index: 25,
            visible: true,
        },
        {
            name: 'abbr',
            caption: 'Сокращенное наименование',
            dataField: 'abbr',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 16,
            visible: true,
        },
        {
            name: 'kodb',
            caption: 'Номер банка',
            dataField: 'kodb',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 150,
            index: 2,
            visible: true,
        },
        {
            name: 'filial',
            caption: 'Филиал',
            dataField: 'filial',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 3,
            visible: true,
        },
        {
            name: 'bic',
            caption: 'БИК',
            dataField: 'bic',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 200,
            index: 4,
            visible: true,
        },
        {
            name: 'adr',
            caption: 'Адрес (старый формат)',
            dataField: 'adr',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 5,
            visible: true,
        },
        {
            name: 'ks',
            caption: 'Корр. счет',
            dataField: 'ks',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 6,
            visible: true,
        },
        {
            name: 'p_ind',
            caption: 'Индекс',
            dataField: 'p_ind',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 150,
            index: 7,
            visible: true,
        },
        {
            name: 'adres',
            caption: 'Адрес (из справочника адресов)',
            dataField: 'adres',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 18,
            visible: true,
        },
        {
            name: 'u_m',
            caption: 'u_m',
            dataField: 'u_m',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 8,
            visible: false,
        },
        {
            name: 'd_m',
            caption: 'd_m',
            dataField: 'd_m',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 9,
            visible: false,
        },
        {
            name: 'kod_parent',
            caption: 'kod_parent',
            dataField: 'kod_parent',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 10,
            visible: false,
        },
        {
            name: 'town',
            caption: 'Город',
            dataField: 'town',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 11,
            visible: true,
        },
        {
            name: 'status',
            caption: 'Удален',
            dataField: 'status',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 12,
            visible: true,
        },
        {
            name: 'ogrn',
            caption: 'ОГРН',
            dataField: 'ogrn',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 20,
            visible: true,
        },
        {
            name: 'inn',
            caption: 'ИНН',
            dataField: 'inn',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 21,
            visible: true,
        },
        {
            name: 'kpp',
            caption: 'КПП',
            dataField: 'kpp',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 22,
            visible: true,
        },
        {
            name: 'okopf',
            caption: 'ОКОПФ',
            dataField: 'okopf',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 23,
            visible: true,
        },
        {
            name: 'prim',
            caption: 'Примечание',
            dataField: 'prim',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 14,
            visible: true,
        },
        {
            name: 'pr_active',
            caption: 'pr_active',
            dataField: 'pr_active',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: -12,
            visible: false,
        },
        {
            name: 'npp',
            caption: 'npp',
            dataField: 'npp',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 13,
            visible: false,
        },
        {
            name: 'telefon',
            caption: 'Телефон',
            dataField: 'telefon',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 15,
            visible: true,
        },
        {
            name: 'd_c',
            caption: 'd_c',
            dataField: 'd_c',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 17,
            visible: false,
        },
        {
            name: 'kod_pay',
            caption: 'kod_pay',
            dataField: 'kod_pay',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: -19,
            visible: false,
        },
        {
            name: 'name_pay',
            caption: 'Обработка платежных требований',
            dataField: 'name_pay',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 19,
            visible: true,
        },
        {
            name: 'kodd',
            caption: 'kodd',
            dataField: 'kodd',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 24,
            visible: false,
        },
        {
            name: 'u_c',
            caption: 'u_c',
            dataField: 'u_c',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 26,
            visible: false,
        },
    ],
    api: {
        select: 'core./core/ks-bank/select/get',
        save: 'core./core/ks-bank/save/set',
    },
    viewId: 'ksbank-view',
};
const args = {
    select: {
        select_args: {
            select_arg: checkbox.value,
        },
    },
};

onMounted(async () => {});

const treeListEditWrapperMountedHandler = async () => {
    treeListRef.value.ref.treeListInstance.on('focusedRowChanged', e => (focusedRow.value = e.row?.data));
    treeListRef.value.ref.treeListInstance.on('editingStart', e => (focusedRow.value = e.data));
};

const onValueChange = async e => {
    checkbox.value = e.value;
    args.select.select_args.select_arg = e.value;

    await treeListRef.value.ref.setDataSource();
};

defineExpose({
    focusedRow,
});
</script>

<script>
export default {
    name: 'ks-bank-view',
};
</script>

<style scoped></style>
